<template>
  <v-container grid-list-md v-show="false">
    <v-layout row wrap id="printProposta">
      <v-flex xs12 sm4 lg3> 
        <img src="../Content/images/logo.png" alt="PlanoRiso" width="110px">        
      </v-flex>          
      <v-flex xs12 sm4 lg4 justify-center>
        <p class="form-titulo" style="text-align: center; font-size: 17px;">RESUMO DA PROPOSTA Nº {{this.financialManagers.proposalNumber}}</p>
      </v-flex>
      <v-flex xs12 sm12 lg12>   
        <p class="tituloProposta" >Responsável Financieiro</p>
      </v-flex>
      <div class="containerProposta" v-if="this.financialManagers.firstName">   
        <p class="subtotal item containerProposta">Nome</p>
        <p class="itemValor">{{this.financialManagers.firstName}}</p>           
      </div>            
      <div class="containerProposta" v-if="this.financialManagers.cpf">   
        <p class="subtotal item containerProposta">CPF</p>
        <p class="itemValor">{{this.financialManagers.cpf}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.matricula">   
        <p class="subtotal item containerProposta">Matricula</p>
        <p class="itemValor">{{this.financialManagers.matricula}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.rg">   
        <p class="subtotal item containerProposta">RG</p>
        <p class="itemValor">{{this.financialManagers.rg}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.dateOfBirth">   
        <p class="subtotal item containerProposta">Nascimento</p>
        <p class="itemValor">{{formatDateBrz(this.financialManagers.dateOfBirth)}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.maritalStatus">   
        <p class="subtotal item containerProposta">Estado Civil</p>
        <p class="itemValor">{{this.financialManagers.maritalStatus}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.motherName">   
        <p class="subtotal item containerProposta">Nome da Mãe</p>
        <p class="itemValor">{{this.financialManagers.motherName}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.susNumber">   
        <p class="subtotal item containerProposta">CNS</p>
        <p class="itemValor">{{this.financialManagers.susNumber}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.cellPhone">   
        <p class="subtotal item containerProposta">Telefone</p>
        <p class="itemValor">{{this.financialManagers.cellPhone}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.email">   
        <p class="subtotal item containerProposta">E-mail</p>
        <p class="itemValor">{{this.financialManagers.email}}</p> 
      </div>
      <v-flex xs12 sm12 lg12>   
        <br>
        <p class="tituloProposta" >Endereço</p>
      </v-flex>
      <div class="containerProposta" v-if="this.financialManagers.cep">   
        <p class="subtotal item containerProposta">CEP</p>
        <p class="itemValor">{{this.financialManagers.cep}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.address">   
        <p class="subtotal item containerProposta">Logradouro</p>
        <p class="itemValor">{{this.financialManagers.address}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.addressNumber">   
        <p class="subtotal item containerProposta">Número</p>
        <p class="itemValor">{{this.financialManagers.addressNumber}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.addressComplement">   
        <p class="subtotal item containerProposta">Complemento</p>
        <p class="itemValor">{{this.financialManagers.addressComplement}}</p> 
      </div>
      <div class="containerProposta" v-if="bairro">   
        <p class="subtotal item containerProposta">Bairro</p>
        <p class="itemValor">{{bairro}}</p> 
      </div>
      <div class="containerProposta" v-if="cidade">   
        <p class="subtotal item containerProposta">Cidade</p>
        <p class="itemValor">{{cidade}}</p> 
      </div>
      <div class="containerProposta" v-if="estado">   
        <p class="subtotal item containerProposta">Estado</p>
        <p class="itemValor">{{estado}}</p> 
      </div>

      <v-flex xs12 sm12 lg12>   
        <br>
        <p class="tituloProposta">Titular</p>
      </v-flex>
      <div class="containerProposta">   
        <p class="subtotal item containerProposta">Nome</p>
        <p class="itemValor">{{this.titular.firstName}}</p> 
      </div>
      <div class="containerProposta">   
        <p class="subtotal item containerProposta">CPF</p>
        <p class="itemValor">{{this.titular.cpf}}</p> 
      </div>
      <div class="containerProposta">   
        <p class="subtotal item containerProposta">Nascimento</p>
        <p class="itemValor">{{formatDateBrz(this.titular.dateOfBirth)}}</p> 
      </div>
      <div class="containerProposta">   
        <p class="subtotal item containerProposta">Estado Civil</p>
        <p class="itemValor">{{this.titular.maritalStatus}}</p> 
      </div>
      <div class="containerProposta">   
        <p class="subtotal item containerProposta">Nome da Mãe</p>
        <p class="itemValor">{{this.titular.motherName}}</p> 
      </div>

      <v-flex xs12 sm12 lg12 v-if="dependentes.firstName != ''">   
        <br>
        <p class="tituloProposta" >Dependentes</p>
      </v-flex>
      <div v-if="dependentes.firstName != ''">
        <div class="flex-container" v-for="dependente in dependentes" :key="`${dependente}`">           
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">Nome</p>
            <p class="itemValor">{{dependente.firstName}}</p> 
          </div>
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">Parentesco</p>
            <p class="itemValor">{{dependente.parentage}}</p> 
          </div>
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">CPF</p>
            <p class="itemValor">{{dependente.cpf}}</p> 
          </div>
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">Nascimento</p>
            <p class="itemValor">{{formatDateBrz(dependente.dateOfBirth)}}</p> 
          </div>
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">Estado Civil</p>
            <p class="itemValor">{{dependente.maritalStatus}}</p> 
          </div>
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">Nome da Mãe</p>
            <p class="itemValor">{{dependente.motherName}}</p> 
          </div>
        </div>
      </div>

      <v-flex xs12 sm12 lg12>   
        <br>
        <p class="tituloProposta" >Informações do Plano</p>
      </v-flex>
      <div class="containerProposta" v-if="this.planoSelecionado[4]">   
        <p class="subtotal item containerProposta">Nome do Plano</p>
        <p class="itemValor">{{this.planoSelecionado[4]}}</p> 
      </div>
      <div class="containerProposta" v-if="this.planoSelecionado[0]">   
        <p class="subtotal item containerProposta">Valor do Plano</p>
        <p class="itemValor">R$ {{this.planoSelecionado[0]}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.responsibility">   
        <p class="subtotal item containerProposta">Valor Total</p>
        <p class="itemValor">R$ {{this.financialManagers.responsibility}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.vendedor">   
        <p class="subtotal item containerProposta">Vendedor</p>
        <p class="itemValor">{{this.financialManagers.vendedor}}</p> 
      </div>
         
      <!-- <v-flex xs12 sm4 lg4 justify-center>
        <p class="form-titulo" style="text-align: center; font-size: 17px;">DECLARAÇÃO DE CIÊNCIA E RECEBIMENTO</p>
        <p class="form-titulo" style="text-align: center; font-size: 17px;">VENDA ONLINE - INDIVIDUAL / FAMILIAR</p>
      </v-flex> -->
      <!-- <p class="itemValor" style="text-align: justify;">
        <strong style="font-weight: bold;">DECLARO</strong>: Que ao preencher a Proposta da operadora recebi todas as orientações necessárias, Minuta de Contrato, inclusive quanto aos prazos de carência, condições para exclusões, que foram integralmente lidos, entendidos e por mim aceitos, sem restrição ao seu conteúdo, tudo para o fiel preenchimento, o que confirmo no site e endosso efetuando o pagamento, não tendo qualquer dúvida quanto à sua aplicação.
        Declaro ainda, que como RESPONSÁVEL FINANCEIRO do contrato, para todos os fins e efeitos do direito, que tenho ciência e repassarei todas as informações aos beneficiários, titular e seus respectivos dependentes, caso haja: <strong style="font-weight: bold;">1.</strong> As condições gerais do Contrato, Aditivo e Proposta, no qual assumo a responsabilidade pelas informações prestadas, inclusive em relação aos beneficiários e que a omissão de circunstâncias que possam influir na aceitação do referido Contrato em destaque, constatação de dados inverídicos ou incompletos poderá ocasionar a denúncia ou a suspensão do contrato, nos termos do Artigo 766 do Código Civil Brasileiro e art. 3º da Resolução nº 2/98 do CONSU; <strong style="font-weight: bold;">2.</strong> O contrato terá a vigência mínima de 12(doze) meses, contados a partir da data de confirmação de pagamento, e será renovado automaticamente por iguais períodos sem cobranças de taxas ou qualquer outro valor no momento da renovação, não havendo ainda incidência de recontagem de carência; <strong style="font-weight: bold;">3.</strong> Caso haja manifestação, do CONTRATANTE, ora RESPONSÁVEL FINANCEIRO, o presente contrato poderá ser extinto, desde que observado o disposto na legislação em vigor, senda dada a CONTRATADA, ora PLANO RISO, pela função de inadimplência nos moldes da Lei 9656/98 e suas correlações; <strong style="font-weight: bold;">4.</strong> Estão cobertos por este contrato todo o Rol de Procedimentos da ANS – Agência Nacional de Saúde Suplementar vigente à época da utilização dos serviços, rol este disponível para consulta pública no site da agência www.ans.gov.br ou na área restrita ao cliente; <strong style="font-weight: bold;">5.</strong> Que tive acesso antes de confirmar a contratação do plano, ao Manual de Orientação para Contratação de Planos de Saúde - MPS e o Guia de Leitura Contratual – GLC; <strong style="font-weight: bold;">6.</strong> Das coberturas, abrangência e segmentação do plano selecionado acima; <strong style="font-weight: bold;">7.</strong> Que as inclusões e exclusões devem observar as diretrizes da legislação em vigor; <strong style="font-weight: bold;">8.</strong> Que o início de vigência será após a confirmação de pagamento, mediante a conferência, aceitação e aprovação dos dados obrigatórios preenchidos na Proposta; <strong style="font-weight: bold;">9.</strong> De que o preenchimento incorreto e/ou fraudulento, bem como, documentos obrigatórios inelegíveis motivará a não aceitação deste contrato, sob pena de cancelamento; <strong style="font-weight: bold;">10.</strong> Que a contar da data de vigência do plano os beneficiários poderão retirar a carteirinha virtual através da área restrita ao cliente no site www.primvaida.com.br e/ou Aplicativo Mobile. <strong style="font-weight: bold;">11.</strong> Que em caso de dúvidas a central de relacionamento com o beneficiário está a disposição (21)3299-4545, inclusive via WhatsApp (21)97164-0379. <strong style="font-weight: bold;">12.</strong> Que ao confirmar e endossar a contratação mediante o pagamento autorizo a CONTRATADA, a solicitar, a qualquer tempo, a dentistas, clínicas e demais estabelecimentos credenciados, informações que julgar necessárias para elucidação de qualquer assunto relacionado ao bom andamento da prestação de serviços, objeto do presente contrato.
      </p> -->
      <footer>
        <br>
        <br>
        <br>
        <img src="../Content/images/logo-ans.png" width="120px">
      </footer>
    </v-layout>
  </v-container>    
</template>

<script>
  import PH from 'print-html-element'
  import axios from 'axios'
  import { baseApiUrl } from '@/global'
  export default {
    data () {
      return {
        nomeUsuario: '',
        planoSelecionado: [],
        financialManagers: {
          contratanteTitular: true,
          confirmPassword: '',
          password: '',
          rg: '',
          rgEmitter: '',
          homePhone: '',
          cellPhone: '',
          cellPhone2: '',
          email: '',
          cep: '',
          address: '',
          addressType: '',
          addressTypeName: '',
          addressNumber: '',
          addressComplement: '',
          district: '',
          city: '',
          state: '',
          proposalNumber: 0,
          contractNumberS4: '',
          responsibility: '',
          cardNumber: '',
          cardValidity: '',
          cardFlag: '',
          cardDayExpiration: 15,
          dateSignatureContract: '',
          formOfPaymentId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: null,
          maritalStatus: null,
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: '',
          nsu: '',
          planoSelecionado: [],
          typeFm: 'FISICA',
          protocoloCancelamento: '',
          vendedor: '' 
        },
        bairro: '',
        estado: '',
        cidade: '',
        titular: {
          parentage: '',
          valuePlan: '',
          lackOfCare: 1,
          rcaId: '',
          dateFirstPayment: '',
          isHolder: '',
          financialManagerId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: '',
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: ''
        },
        dependentes: [{
          parentage: '',
          valuePlan: '',
          lackOfCare: 1,
          rcaId: '',
          dateFirstPayment: '',
          isHolder: '',
          financialManagerId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: '',
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: ''
        }]
      }
    },

    mounted : function() {
      if(localStorage.getItem('proposta') != null)
        this.financialManagers = JSON.parse(localStorage.getItem('proposta'))
      this.consultaCEP()
      this.carregaBeneficiarios()
      this.carregaPlano()           
    },

    methods: {
      print() {
        var opts = {
          /* stylesheets:"<link rel='stylesheet' href='../Content/styles/minify/main.min.css'>", */
          pageTitle: "Proposta Nº "+this.financialManagers.proposalNumber
        }
        PH.printElement(document.getElementById('printProposta'),opts)
      },

      formatDateBrz (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      consultaCEP() {
        if(/^[0-9]{5}-[0-9]{3}$/.test(this.financialManagers.cep)) {
          axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.financialManagers.cep}).then(res => {     
            if(res.data != null) {
              this.financialManagers.address = res.data.Logradouro
              this.cidade = res.data.Municipio
              this.financialManagers.city = res.data.IdMunicipio
              this.estado = res.data.Uf
              this.financialManagers.state = res.data.IdUf
              this.bairro = res.data.Bairro
              this.financialManagers.district = res.data.IdBairro
              this.financialManagers.addressType = res.data.IdTipoLogradouro
              this.financialManagers.addressTypeName = res.data.TipoLogradouro
            } else {
              var vmcep = this;
              vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
              this.financialManagers.address = ''
              this.cidade = ''
              this.financialManagers.city = ''
              this.estado = ''
              this.financialManagers.state = ''
              this.bairro = ''
              this.financialManagers.district = ''
              this.financialManagers.addressType = ''
            }             	
          })
        }           
      },

      async carregaBeneficiarios() {
        await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.financialManagers.id})
        .then(response => {
          if (response.data) {
            let titular = response.data.dependentes.filter(dependente => dependente.isHolder == true)
            this.titular = titular[0]
            this.dependentes = response.data.dependentes.filter(dependente => dependente.isHolder == false)
          }
        })
      },

      async carregaPlano() {
        await axios.post(`${baseApiUrl}FinancialManagers/proposta`, {"id": this.financialManagers.id}).then(async res => {
          let plano = res.data.plano
          await axios.get(`${baseApiUrl}Plans?filter[where][id]=${plano.id}`).then(resp => {
            if (res.data != null) {
              this.planoSelecionado.push(
                resp.data[0].value,
                resp.data[0].area_atuacao,
                resp.data[0].qualificacao,
                resp.data[0].registro,
                resp.data[0].name,
                resp.data[0].cobertura,
                resp.data[0].id,
                "",
                resp.data[0].urlMinutaContrato,
                resp.data[0].urlMinutaAditivo,
                resp.data[0].urlManual,
                resp.data[0].urlGuia,
                resp.data[0].urlCobertura
              )
            }            
          })
        })
      },

    }
  }
</script>

<style>
  .tituloProposta {
    font-size:15px;
    font-weight:700;
    color:#797a7a;
    margin-bottom:5px;  
    text-align: center;  
    border: 1px solid; 
    border-color: #0098DA;
    border-radius: 10px;
    padding: 8px;
  }

  .flexProposta {
    display: flex;
    flex-wrap: nowrap;
  }

  .item {
    margin: 10px auto;
    font-size:18px;
    color: #0098DA;
  }

  .containerProposta {
    font-size:15px;
    min-width: auto;
    margin: 5px 20px 0 0;
  }

  .itemValor {
    margin: 5px auto;
    font-size:15px;
    color:#797a7a;
  }

  .flex-container {
    display: flex;
    flex-wrap: nowrap;
  }

  .flex-container > div {
    min-width: auto;
    margin: 5px 20px auto auto;
    font-size:15px;
    color:#797a7a;
  }
</style>